import React from "react";
import "./Vendor.scss";
import VendorList from "./VendorList";
function Vendor() {
  return (
    <div className="vendorPage">
      <VendorList />
    </div>
  );
}

export default Vendor;
